import React, { useState } from "react";
import { Row, Col, Avatar, Typography, List, message } from "antd";
import {
  LeftOutlined,
  UserOutlined,
  LockOutlined,
  FileTextOutlined,
  QuestionCircleOutlined,
  BankOutlined,
  IdcardOutlined,
  LogoutOutlined,
} from "@ant-design/icons";

// Import all your sub-screens
import MyProfilePage from "./MyProfilePage";
import ChangePasscodeScreen from "./ChangePasscodeScreen";
import {updatePasscode} from "../../../api/UserAPI";
import { AlertTriangle } from "lucide-react";


const { Title, Text } = Typography;

const ProfileScreen = ({ onBack, user, handleLogout , setUserDetails}) => {
  const [activePage, setActivePage] = useState(null);

  const menuItems = [
    { icon: <UserOutlined />, label: "My profile" },
    { icon: <IdcardOutlined />, label: "My Pay ID" },
    { icon: <BankOutlined />, label: "Transaction limits & charges" },
    { icon: <LockOutlined />, label: "Change passcode" },
    { icon: <FileTextOutlined />, label: "Legal Documents" },
    { icon: <QuestionCircleOutlined />, label: "Help & Support" },
  ];


const handlePasscodeChange = async (form) => {
  try {
    const response = await updatePasscode(form);
    console.log("Passcode change API response:", response);

    // ✅ API structure: response.data.data
    const resData = response.data;

    console.log("Passcode change response data:", resData);

    if (resData && resData.status === 1) {
      // Success case
      setUserDetails(prev => ({
        ...prev,
        transactionPin: form.newPassword,
      }));
      message.success(resData.message || "Passcode updated successfully");
      setActivePage(null);  

    } else {
      // Error case
      message.error(resData?.message || "Failed to update passcode");
    }
  } catch (error) {
    console.error("Passcode change error:", error);
    message.error("Error updating passcode");
  }
};



  // 🔹 Render subpages instead of menu
  if (activePage) {
    switch (activePage) {
      case "My profile":
        return (
          <MyProfilePage
            onBack={() => setActivePage(null)}
            user={user}
            handleLogout={handleLogout}
          />
        );

      case "Change passcode":
        return (
          <ChangePasscodeScreen
            userDetails={{ transactionPin: user.transactionPin }}
            onBack={() => setActivePage(null)}
            onPasscodeChange={handlePasscodeChange}   // 🔹 pass handler down
          />
        );
      // case "Legal Documents":
      //   return <LegalDocumentsScreen onBack={() => setActivePage(null)} />;
      // case "Help & Support":
      //   return <HelpSupportScreen onBack={() => setActivePage(null)} />;
      default:
        setActivePage(null);
    }
  }

  // 🔹 Default Profile Menu
  return (
    <div style={{ padding: "16px", minHeight: "100vh", background: "#fff" }}>
      {/* Header */}
      <Row align="middle" style={{ marginBottom: 24 }}>
        <LeftOutlined
          style={{ fontSize: 18, cursor: "pointer", marginRight: 12 }}
          onClick={onBack}
        />
        <Title level={5} style={{ margin: 0 }}>
          Profile
        </Title>
      </Row>

      {/* User Info */}
      <Row align="middle" style={{ marginBottom: 24 }}>
        <Avatar
          size={56}
          style={{ background: "#1890ff" }}
          icon={<UserOutlined />}
        />
        <div style={{ marginLeft: 12 }}>
          <Title level={5} style={{ margin: 0 }}>
            {user?.name || "Ruchi Kwatra"}
          </Title>
          <Text type="secondary">Brisbane</Text>
        </div>
      </Row>

      {/* Menu List */}
      <List
        itemLayout="horizontal"
        dataSource={menuItems}
        renderItem={(item) => (
          <List.Item
            style={{ cursor: "pointer" }}
            onClick={() => setActivePage(item.label)}
          >
            <List.Item.Meta
              avatar={item.icon}
              title={<Text>{item.label}</Text>}
            />
          </List.Item>
        )}
      />

      {/* Footer Options */}
      <div style={{ marginTop: 40 }}>
        <Row align="middle" style={{ marginBottom: 16 }}>
          <BankOutlined style={{ marginRight: 8, color: "#1890ff" }} />
          <Text strong>Create Business Account</Text>
        </Row>
        <Row align="middle" onClick={handleLogout}>
          <LogoutOutlined style={{ marginRight: 8, color: "red" }} />
          <Text type="danger">Log out</Text>
        </Row>
      </div>
    </div>
  );
};

export default ProfileScreen;
